


































































































































































































































































































import {
  ApiCommodityCommodityMarketingDetailResponse,
  apiMarketingCouponReceiveOpen,
} from '@/api'
import { bindEvent } from 'vtils'
import {
  computed,
  onBeforeUnmount,
  onMounted,
  ref,
} from '@vue/composition-api'
import { defineClassComponent, useNewRoute } from '@/hooks'
import { RequiredDeep } from 'vtils/types'
import { submit } from '@/utils'

export default defineClassComponent<{
  data: any
  skuId?: string
  zIndex: number
  trigger?: string
}>(
  {
    props: ['data', 'skuId', 'zIndex', 'trigger'],
  },
  ({ props, ctx }) =>
    class {
      constructor() {
        useNewRoute(this.visible)

        if (props.trigger) {
          let off: any
          onMounted(() => {
            off = bindEvent(
              document.querySelector<HTMLDivElement>(
                props.trigger!.startsWith('.') ||
                  props.trigger!.startsWith('#')
                  ? props.trigger!
                  : `.${props.trigger}`,
              )!,
            )('click', () => {
              this.visible.value = !this.visible.value
            })
          })
          onBeforeUnmount(() => {
            off?.()
          })
        }
      }

      visible = ref(false)

      // 营销数据
      marketingData = computed(() => {
        return {
          ...props.data,
          groupBuyings:
            (props.skuId &&
              props.data.groupBuying?.skuInfos
                ?.find((sku: any) => sku.skuId === props.skuId)
                ?.ladderConfig?.map(
                  (item: any) =>
                    `${item.userNum}人成团单价${item.ladderPrice}元`,
                )) ||
            [],
        }
      })

      allCoupons = computed(() => {
        return [
          ...(this.marketingData.value.fullCoupons || []),
          ...(this.marketingData.value.marketingDiscountCoupons || []).map(
            (item: any) => {
              item.isZhe = true
              return item
            },
          ),
        ]
      })

      // 格式化优惠券
      formatCoupon = (
        coupon: RequiredDeep<ApiCommodityCommodityMarketingDetailResponse>['fullCoupons'][0],
        可用样式 = false,
      ) => {
        return coupon.minPoint === 0
          ? `无门槛${可用样式 ? '' : `减${coupon.discountAmt}元`}`
          : `满${coupon.minPoint}元${
              可用样式 ? '可用' : `减${coupon.discountAmt}元`
            }`
      }

      formatZheCoupon = (coupon: any) => {
        return `${coupon.discountRatio}折优惠(${[
          coupon.minPoint ? `满${coupon.minPoint}元` : '',
          coupon.discountSingleOrderMaxLimit
            ? `最高${coupon.discountSingleOrderMaxLimit}元`
            : '',
        ]
          .filter(Boolean)
          .join(',')})`.replace('()', '')
      }

      // 点击优惠
      handleTriggerClick = () => {
        this.visible.value = !this.visible.value
      }

      // 点击去使用优惠券
      handleUseClick = () => {
        this.visible.value = false
      }

      // 点击领取优惠券
      handleGetClick = (item: any) => {
        submit(async $ => {
          $.start('领取中...')
          await apiMarketingCouponReceiveOpen(
            {
              couponActId: item.activityId,
            },
            {
              errorMessageMap: {
                '没领到哦，你的单张券已领取达到上限': [1001, 1007, 1008],
                '活动已结束，无法继续领取': [1003, 1004, 1005],
                '领取失败，当前不在领取时段内': [1009],
                '领取失败，不符合领券要求': [1012],
              },
            },
          )
          ctx.$emit('refresh')
          await $.success('领取成功')
        })
      }
    },
)
